import L from "leaflet";
// 🚨 Asegúrate de que esta ruta a tu instancia de Axios sea correcta.
import axios from "../../services/axios"; 

// ==========================================================
// 1. CONSTANTES Y UTILIDADES VISUALES
// ==========================================================
export const categoryColors = {
  "Atractivos Turísticos": "green",
  "Circuitos Turísticos": "blue",
  Hoteles: "red",
  Hostales: "orange",
  Gastronomía: "purple",
  "Agencia de Viajes": "brown",
  "Guías Turísticos": "teal",
  Artesanías: "pink",
  "Centros Comerciales": "gold",
  "Transporte Publico": "black",
};

export const getCategoryIcon = (categoria) =>
  L.divIcon({
    className: "custom-marker",
    html: `<div style="
      background-color: ${categoryColors[categoria] || "gray"};
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid white;
      box-shadow: 0 0 6px rgba(0,0,0,0.5);
    "></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10],
  });

// ==========================================================
// 2. DECODIFICACIÓN DE POLILÍNEAS
// ==========================================================

/**
 * Decodifica una cadena de polilínea codificada de Google en un array de coordenadas [lat, lng].
 * @param {string} encoded La polilínea codificada.
 * @returns {Array<[number, number]>} Array de coordenadas.
 */
export const decodePolyline = (encoded) => {
  let index = 0,
      lat = 0,
      lng = 0,
      array = [],
      len = encoded.length;

  while (index < len) {
      let b,
          shift = 0,
          result = 0;
      
      // Decodificar latitud
      do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
      } while (b >= 0x20);

      let dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
      lat += dlat;

      shift = 0;
      result = 0;
      
      // Decodificar longitud
      do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
      } while (b >= 0x20);
      
      let dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
      lng += dlng;

      array.push([lat / 1e5, lng / 1e5]);
  }
  return array;
};

// ==========================================================
// 3. FUNCIÓN DE RUTA (LLAMA AL PROXY DE LARAVEL)
// ==========================================================

/**
 * Llama a tu propio servidor backend (proxy) para obtener la ruta.
 * Resuelve el error CORS.
 * @param {array} destinos - Array de objetos destino { latitud, longitud }
 * @returns {string | null} Polilínea codificada de Google, o null si falla.
 */
export const fetchGoogleRoute = async (destinos) => {
  if (destinos.length < 2) return null;

  try {
    // ✅ CORREGIDO: Enviar en formato correcto { destinos: [...] }
    console.log("📦 Enviando destinos al backend:", destinos);

    const response = await axios.post('/google-route', { destinos });

    // El backend devuelve { encodedPolyline: "..." }
    if (response.data && response.data.encodedPolyline) {
      return response.data.encodedPolyline;
    }

    console.warn('El backend respondió pero no devolvió la polilínea. Puede ser error de ruta (ZERO_RESULTS).');
    return null;

  } catch (error) {
    // Esto captura fallos en la comunicación con tu propio backend.
    console.error("Fallo al obtener la ruta a través del backend (Proxy):", error);
    return null;
  }
};
